module.exports = __webpack_public_path__ + "static/img/travel_agency.9223eeb.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/travel_agency.png
// module id = XjC3
// module chunks = 1